<template>
  <div class="hero">
    <video
      autoplay
      playsinline
      muted
      loop
      alt="hero video"
      id="mainvideo"
      preload="none"
      src="/videos/INTRO VIDEO.mp4"
      crossorigin="anonymous"
    >
      <source src="/videos/INTRO VIDEO.mp4" type="video/mp4" />
    </video>
    <video
      playsinline
      muted
      loop
      class="video-backdrop"
      alt="hero video"
      id="backdropvideo"
      preload="none"
      src="/videos/INTRO VIDEO.mp4"
      crossorigin="anonymous"
      v-if="showBackdrop"
    >
      <source src="/videos/INTRO VIDEO.mp4" type="video/mp4" />
    </video>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showBackdrop: false,
    };
  },
  mounted() {
    const mainVideo = document.getElementById("mainvideo");
    let backdropVideo = null;

    mainVideo.load();

    mainVideo.addEventListener("canplay", () => {
      this.showBackdrop = true;

      this.$nextTick(() => {
        backdropVideo = document.getElementById("backdropvideo");
        backdropVideo.load();
        backdropVideo.play();
      });
    });
  },
};
</script>
<style lang="scss" scoped>
.hero {
  min-height: 500px;
  height: calc(calc(var(--vh, 1vh) * 100) - var(--top-nav-height, 80px));
  background: #000;
  position: relative;
  video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: center;
    z-index: 1;
  }
  .video-backdrop {
    z-index: 0;
    object-fit: cover;
    filter: blur(50px);
    opacity: 0.8;
  }

  @media (max-width: 768px) {
    height: 100%;
    min-height: 200px;
    background: transparent;
    video {
      position: static;
      height: auto;
      max-height: 100%;
      &.video-backdrop {
        display: none;
      }
    }
  }
}
</style>